export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="11" fill="#E05638" />
    <path d="M32 15.5V9.5h4.5v10" fill="#0B0F17" />
    <path d="M7.5 25.5 24 11l16.5 14.5" fill="none" stroke="#0B0F17" strokeWidth="4.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M29.6 30.2a6.6 6.6 0 1 0 0 7.6" fill="none" stroke="#0B0F17" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ sub = "text-slate-300" }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-10 w-10 shrink-0 transition-transform duration-500 group-hover:-rotate-6" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-[1.45rem] font-bold uppercase tracking-[0.06em] text-white">Christian</span>
      <span className={`mt-1 text-xs font-semibold uppercase tracking-[0.3em] ${sub}`}>Bedachungen</span>
    </span>
  </span>
);
